import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { NgClass, NgStyle } from "@angular/common";

@Component({
    selector: "rask-color-picker",
    templateUrl: "./color-picker.component.html",
    styleUrls: ["./color-picker.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        NgStyle
    ]
})
export class ColorPickerComponent {

  @Input() colors: string[] = [];
  @Input() color: string;
  @Output() colorChange = new EventEmitter<string>();

  select(col) {
      this.colorChange.emit(col);
  }

  isSelected(col) {
      return (col === this.color);
  }

}
